import React from 'react';
import { FACEBOOK_PAGE_URL } from '../constants/facebookPageUrl';
import {
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  TikTokBadgeLogo,
  XIcon,
} from './socialPlatformIcons';

const SOCIAL_BADGES = [
  {
    id: 'instagram',
    href: 'https://www.instagram.com/raheasyke/',
    label: 'Instagram',
    className: 'instagram',
    Icon: InstagramIcon,
  },
  {
    id: 'facebook',
    href: FACEBOOK_PAGE_URL,
    label: 'Facebook',
    className: 'facebook',
    Icon: FacebookIcon,
  },
  {
    id: 'linkedin',
    href: 'https://linkedin.com/company/raheasy',
    label: 'LinkedIn',
    className: 'linkedin',
    Icon: LinkedInIcon,
  },
  {
    id: 'x',
    href: 'https://x.com/raheasy',
    label: 'X',
    className: 'x',
    Icon: XIcon,
    iconOnly: true,
  },
  {
    id: 'tiktok',
    href: 'https://www.tiktok.com/@raheasy',
    label: 'TikTok',
    className: 'tiktok',
    Icon: TikTokBadgeLogo,
    wordmarkOnly: true,
  },
];

export const SOCIAL_PROFILE_URLS = Object.fromEntries(
  SOCIAL_BADGES.map(({ id, href }) => [id, href])
);

/** Colorful follow buttons — same brand icons as the footer. */
export default function SocialFollowBadges({ className = 'social-feed-badges' }) {
  return (
    <div className={className} role="navigation" aria-label="Follow Raheasy on social media">
      {SOCIAL_BADGES.map(({ id, href, label, className: btnClass, Icon, iconOnly, wordmarkOnly }) => (
        <a
          key={id}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className={`social-link-btn ${btnClass}${iconOnly ? ' social-link-btn--icon-only' : ''}${wordmarkOnly ? ' social-link-btn--wordmark-only' : ''}`}
          aria-label={label}
        >
          {wordmarkOnly ? (
            <Icon height={18} />
          ) : (
            <>
              <Icon size={20} />
              {!iconOnly ? label : null}
            </>
          )}
        </a>
      ))}
    </div>
  );
}
